import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Select from 'react-select'
import find from 'lodash/find'
import shortid from 'shortid'
import * as timesheetHelper from '../../helpers/timesheet'

const customStyles = {
  control: (base, state) => ({
    ...base,
    height: 30,
    background: !state.isDisabled ? "#FFFFFF" : '#e9ecef',
    minHeight: 30,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    width: 15,
    padding: 0,
  }),
}
const invalidStyles = {
  control: (base, state) => ({
    ...base,
    border: !state.isFocused ? '1px solid #dc3545' : '',
    background: "#FFFFFF",
    ...base,
    height: 30,
    minHeight: 30,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    width: 15,
    padding: 0,
  }),
}

export const ApproverRow = (props) => {
  const { project, myProjects } = props
  const { isEdit } = props
  const { handleInputMyTimesheet } = props
  const projectData = timesheetHelper.findProject(project.project_id, myProjects)
  const approvers = timesheetHelper.createApproverList(projectData.approvers)
  const approver = find(approvers, { value: project.approver_id })

  return (
    <Row>
      <ManagerCol>
        <SelectLocation
          key={ shortid() }
          name='approver_id'
          styles={ approver ? customStyles : invalidStyles }
          options={ approvers }
          isDisabled={ !isEdit }
          onChange={ (e) => handleInputMyTimesheet('approver_id', e, project.key) }
          value={ approver }
        />
      </ManagerCol>
    </Row>
  )
}


ApproverRow.propTypes = {
  isEdit: PropTypes.bool,
  myProjects: PropTypes.array,
  project: PropTypes.object,
  handleInputMyTimesheet: PropTypes.func,
}
ApproverRow.defaultProps = {
  isEdit: false,
  data: {},
  approvers: [],
  myProjects: [],
  project: {},
  handleInputMyTimesheet: () => {},
}

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 30%;
  margin-left: 1% !important;
  margin-right: 1% !important;
  padding-right: 1% !important;
  border-bottom: 1px solid #CCCCCC;
`
const LocationCol = styled.div`
  width: 35%;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  padding-right: 10px;
  margin-top: 10px;
`
const ManagerCol = styled(LocationCol)`
  width: 100%;
  margin-right: 0px;
  padding-right: 0px;
`
const SelectLocation = styled(Select)`
  font-family: 'Gotham' !important;
  width : 100%;
  height : 100%;
  margin-bottom: 10px;
  font-size: 12px;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/my-timesheet/approver-row.js